if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<button type="button" class="zoom__exit">${KROWN.settings.symbols.zoom_out}</button>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.onMouseMoveHandlerBinded = this.#onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.#onResizeHandler.bind(this);
			this.onCloseHandlerBound = this.#productZoomUnmount.bind(this);
			this.onImageLoadHandlerBound = this.#productZoomMount.bind(this);
			this.onKeyDownHandlerBound = (event) => {
				if (event.key === 'Escape') {
					event.preventDefault();
					this.#productZoomUnmount();
				} else if (event.key === 'Tab') {
					event.preventDefault();
					this.zoom.querySelector('.zoom__exit').focus();
				}
			};

			this.closest('.product-gallery-item').addEventListener('click', (e)=>{
				if ( window.matchMedia('(max-width: 767px)').matches ) return;
				clearTimeout(this.zoom.cleanupTimeout);
				this.previousFocus = document.activeElement;
				const closeButton = this.zoom.querySelector('.zoom__exit');
				closeButton.setAttribute('aria-label', KROWN.settings.locales.zoom_close_label);
				closeButton.addEventListener('click', this.onCloseHandlerBound);
				this.zoom.addEventListener('keydown', this.onKeyDownHandlerBound);
				this.zoom.setAttribute('role', 'dialog');
				this.zoom.setAttribute('aria-modal', 'true');
				this.zoom.setAttribute('aria-label', this.closest('.product-gallery-item').querySelector('img')?.alt || KROWN.settings.locales.zoom_close_label);
				this.zoom.classList.add('opened');
				closeButton.focus();
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this.#productZoomMount();
				} else {
					this.image.addEventListener('load', this.onImageLoadHandlerBound, { once: true });
				}
			});

		}

		#onMouseMoveHandler(e){
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		#onResizeHandler(){

			const rf = window.innerWidth > 768 ? 1 : 2;

			if ( this.image.classList.contains('portrait') ) {
				this.image.style.width = ( window.innerWidth*rf ) + 'px';
				this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
			} else {

				this.image.style.height = ( window.innerHeight*rf ) + 'px';
				this.image.style.width = ( window.innerHeight*rf * this.image.dataset.ratio ) + 'px';

				if ( this.image.offsetWidth < window.innerWidth ) {
					this.image.style.width = ( window.innerWidth*rf ) + 'px';
					this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
				}

			}

			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;

		}

		#productZoomMount(image) {
			if (!this.zoom.classList.contains('opened')) return;

			this.image.style.left = 0;
			this.image.style.top = 0;

			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.#onResizeHandler();

			setTimeout(()=>{
				if (!this.zoom.classList.contains('opened')) return;
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
			}, 50);

		}

		#productZoomUnmount() {

			this.zoom.classList.remove('opened');
			this.image.removeEventListener('load', this.onImageLoadHandlerBound);
			this.zoom.removeAttribute('aria-modal');
			this.zoom.removeEventListener('keydown', this.onKeyDownHandlerBound);
			this.zoom.querySelector('.zoom__exit').removeEventListener('click', this.onCloseHandlerBound);
			this.previousFocus?.focus();

			window.removeEventListener('resize', this.onResizeHandlerBinded);
			window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
			this.zoom.cleanupTimeout = setTimeout(()=>{
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
			}, 300);

		}

		disconnectedCallback() {
			window.removeEventListener('resize', this.onResizeHandlerBinded);
			window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}
